/* PRISKEL · motion: the glint, add-to-bag feedback, offer + trust animations (phase 1); banner, loupe, reels, page transitions (phase 2); emblem, wishlist, variants (phase 3).
   Plays once per element, only on transform/opacity, and stays still for reduced motion. */
(function () {
  if (window.__pkMo) return; window.__pkMo = 1;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { document.documentElement.classList.remove('pk-mo'); return; }
  var D = document, H = D.documentElement;
  H.classList.add('pk-mo');

  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }
  function tween(ms, step, done) {
    var s = performance.now();
    function k(n) { var t = Math.min(1, (n - s) / ms); step(easeOut(t)); if (t < 1) requestAnimationFrame(k); else if (done) done(); }
    requestAnimationFrame(k);
  }
  function posd(el) { if (getComputedStyle(el).position === 'static') el.style.position = 'relative'; }

  /* ---------- reveal-on-view ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (!e.isIntersecting) return; io.unobserve(e.target); var f = e.target.__pkIn; e.target.__pkIn = null; if (f) f(e.target); });
  }, { threshold: 0.35, rootMargin: '0px 0px -6% 0px' }) : null;
  function onView(el, fn) { if (!el || el.__pkSeen) return; el.__pkSeen = 1; if (!io) return fn(el); el.__pkIn = fn; io.observe(el); }

  /* ---------- the glint ---------- */
  function glint(host, delay, chip) {
    if (!host) return;
    var g = host.querySelector(':scope > .pk-gl');
    if (!g) { posd(host); g = D.createElement('i'); g.className = 'pk-gl' + (chip ? ' pk-gl--chip' : ''); g.setAttribute('aria-hidden', 'true'); host.appendChild(g); }
    g.classList.remove('is-on'); void g.offsetWidth;
    g.style.animationDelay = (delay || 0) + 'ms';
    g.classList.add('is-on');
  }

  /* product photos: one soft sweep as each card arrives, staggered in rows */
  var wave = 0, waveT = 0;
  function cards(root) {
    (root || D).querySelectorAll('[data-pk-pc],.pk-cl__img').forEach(function (c) {
      if (c.__pkCard) return; c.__pkCard = 1;
      onView(c, function (el) { clearTimeout(waveT); waveT = setTimeout(function () { wave = 0; }, 260); glint(el, (wave++ % 4) * 140); });
    });
  }

  /* ---------- PDP ---------- */
  function pdp() {
    var pd = D.querySelector('.pk-pd'); if (!pd) return;

    var hero = pd.querySelector('.pk-pd__slide:first-child .pk-pd__zbtn');
    if (hero) { var im = hero.querySelector('img'); var go = function () { glint(hero, 450); }; if (im && !im.complete) im.addEventListener('load', go, { once: true }); else go(); }

    var save = pd.querySelector('.pk-pd__save');
    if (save) onView(save, function (el) { if (!el.hidden) glint(el, 1100, 1); });

    var flag = pd.querySelector('.pk-pd__flag');
    if (flag) onView(flag, function (el) { [400, 7000, 14000].forEach(function (t) { setTimeout(function () { glint(el, 0, 1); }, t); }); });

    /* review count rises to its number once */
    var rate = pd.querySelector('.pk-pd__rate');
    if (rate) onView(rate, function (el) {
      var w = D.createTreeWalker(el, NodeFilter.SHOW_TEXT), n;
      while ((n = w.nextNode())) {
        var m = n.nodeValue.match(/^(.*?)(\d[\d,]*)(\s+reviews.*)$/);
        if (!m) continue;
        var node = n, pre = m[1], post = m[3], raw = m[2], end = +raw.replace(/,/g, ''), comma = raw.indexOf(',') > -1;
        if (end < 10) break;
        tween(1300, function (t) { var v = Math.round(end * t); node.nodeValue = pre + (comma ? v.toLocaleString('en-IN') : v) + post; });
        break;
      }
    });

    /* trust icons draw themselves; the waterproof drop falls and ripples */
    var usp = pd.querySelector('.pk-pd__usp');
    if (usp) {
      usp.querySelectorAll('li').forEach(function (li, i) {
        li.style.setProperty('--i', i);
        var ps = li.querySelectorAll('svg path');
        ps.forEach(function (p) {
          p.setAttribute('pathLength', '1');
          var d = p.getAttribute('d') || '';
          if (d.indexOf('M19.6 2.2') === 0) p.classList.add('pk-tw');
        });
        if (ps[0] && (ps[0].getAttribute('d') || '').indexOf('M12 2.8') === 0) {
          li.classList.add('is-drop');
          var ui = li.querySelector('.pk-pd__ui');
          if (ui) { var r = D.createElement('span'); r.className = 'pk-rip'; r.setAttribute('aria-hidden', 'true'); ui.appendChild(r); }
        }
      });
      usp.classList.add('is-armed');
      onView(usp, function (el) { el.classList.add('is-in'); });
    }
  }

  /* Stack & Save: the saving counts up when a tier is chosen */
  function countUp(el) {
    var txt = el.textContent, m = txt.match(/^(.*?₹\s?)(\d[\d,]*)(.*)$/);
    if (!m) return;
    var pre = m[1], post = m[3], end = +m[2].replace(/,/g, ''), last = txt, stop = false;
    if (!end) return;
    tween(650, function (t) {
      if (stop) return;
      if (el.textContent !== last) { stop = true; return; }
      last = pre + Math.round(end * t).toLocaleString('en-IN') + post; el.textContent = last;
    }, function () { if (!stop) el.textContent = txt; });
  }
  D.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-pkp-tier]');
    if (t && t.getAttribute('data-pkp-tier') !== '1') {
      setTimeout(function () { var s = t.querySelector('span'); if (s) countUp(s); }, 30);
    }
    var c = e.target.closest && e.target.closest('[data-pk-copy]');
    if (c) { c.classList.remove('pk-copied'); void c.offsetWidth; c.classList.add('pk-copied'); glint(c, 0, 1); setTimeout(function () { c.classList.remove('pk-copied'); }, 1700); }
  });

  /* ---------- add to bag ---------- */
  var src = null, srcAt = 0, newKey = null;
  var CHECK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path pathLength="1" d="M5 12.5l4.2 4.2L19 7"/></svg>';
  D.addEventListener('pointerdown', function (e) {
    var b = e.target.closest && e.target.closest('button,a,[role="button"]');
    if (!b || b.closest('#pk-cart') || b.matches('[data-pk-cart-open],a[href$="/cart"]')) return;
    src = b; srcAt = Date.now();
  }, true);
  D.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target.closest) { var b = e.target.closest('button'); if (b && !b.closest('#pk-cart')) { src = b; srcAt = Date.now(); } } }, true);
  function isAdd(b) { return b.matches('[data-pkp-atc],[data-pkp-skatc],[data-pkp-qadd],[name="add"],[type="submit"]') || /add|bag|cart/i.test((b.getAttribute('aria-label') || '') + ' ' + b.textContent); }
  function fresh() { return src && Date.now() - srcAt < 5000 && D.contains(src); }

  function busy(b, on) {
    if (!b) return;
    var l = b.querySelector(':scope > .pk-bl');
    if (on) { if (!l) { posd(b); l = D.createElement('span'); l.className = 'pk-bl'; l.setAttribute('aria-hidden', 'true'); b.appendChild(l); } }
    else if (l) l.remove();
  }
  function added(b) {
    if (!b || b.__pkOk) return; b.__pkOk = 1; if (b === src) src = null; busy(b, false); posd(b);
    var ok = D.createElement('span'); ok.className = 'pk-ok'; ok.setAttribute('aria-hidden', 'true');
    var cs = getComputedStyle(b), bg = cs.backgroundColor;
    if (!bg || bg === 'transparent' || /rgba\(.*,\s*0\)$/.test(bg)) { ok.style.background = '#2F2B29'; ok.style.color = '#FBF6EE'; }
    ok.innerHTML = CHECK + (b.offsetWidth > 96 ? '<span>Added</span>' : '');
    b.appendChild(ok);
    requestAnimationFrame(function () { ok.classList.add('is-on'); });
    setTimeout(function () { ok.classList.remove('is-on'); setTimeout(function () { ok.remove(); b.__pkOk = 0; }, 450); }, 2300);
  }

  var ADD = /\/cart\/add(\.js)?(\?|$)/i, pf = window.fetch;
  if (pf) window.fetch = function (input, init) {
    var url = ''; try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
    var p = pf.apply(this, arguments);
    if (ADD.test(url) && fresh()) {
      var b = src; busy(b, true);
      p.then(function (r) {
        if (!r || !r.ok) { busy(b, false); return; }
        added(b);
        r.clone().json().then(function (d) { var k = d && (d.key || (d.items && d.items[0] && d.items[0].key)); if (k) { newKey = k; markNew(); } }).catch(function () {});
      }, function () { busy(b, false); });
    }
    return p;
  };

  /* ---------- the bag ---------- */
  var dlg = D.getElementById('pk-cart'), body = dlg && dlg.querySelector('[data-pk-c-body]');
  function markNew() {
    if (!newKey || !body) return;
    var li = newKey === '__first' ? body.querySelector('.pk-cart__it') : body.querySelector('.pk-cart__it[data-key="' + (window.CSS && CSS.escape ? CSS.escape(newKey) : newKey) + '"]');
    if (!li || li.classList.contains('pk-new')) return;
    newKey = null;
    li.classList.add('pk-new');
    glint(li.querySelector('.pk-cart__im'), 350);
  }
  if (dlg) {
    var tier = dlg.querySelector('[data-pk-c-tier]');
    var prevW = 0, prevN = 0, pendingBump = false, wasOpen = dlg.open;

    new MutationObserver(function () {
      if (dlg.open && !wasOpen) {
        prevW = 0;
        if (fresh() && isAdd(src)) { added(src); if (!newKey) newKey = '__first'; }
      }
      if (!dlg.open && wasOpen && pendingBump) { pendingBump = false; setTimeout(bump, 320); }
      wasOpen = dlg.open;
    }).observe(dlg, { attributes: true, attributeFilter: ['open'] });

    if (tier) new MutationObserver(function () {
      var fill = tier.querySelector('.pk-cart__fill'), trk = tier.querySelector('.pk-cart__track');
      if (!fill || !trk) return;
      var to = parseFloat(fill.style.width) || 0, n = +trk.getAttribute('aria-valuenow') || 0, from = prevW;
      if (to !== from) {
        fill.style.transition = 'none'; fill.style.width = from + '%'; void fill.offsetWidth;
        fill.style.transition = 'width .95s cubic-bezier(.2,.7,.2,1)'; fill.style.width = to + '%';
      }
      if (prevN && n > prevN) {
        var node = tier.querySelector('.pk-cart__node.is-cur');
        if (node) setTimeout(function () { var s = D.createElement('span'); s.className = 'pk-burst'; s.setAttribute('aria-hidden', 'true'); s.innerHTML = '<i></i><i></i><i></i><i></i><i></i><i></i>'; node.appendChild(s); setTimeout(function () { s.remove(); }, 1300); }, 850);
        var msg = tier.querySelector('.pk-cart__tier-m'); if (msg) msg.classList.add('pk-up');
      }
      prevW = to; prevN = n;
    }).observe(tier, { childList: true });

    if (body) new MutationObserver(markNew).observe(body, { childList: true });
  }

  /* bag count: a small lift once the bag is closed, so it's seen */
  function bump() {
    D.querySelectorAll('[data-pk-cart-count]').forEach(function (el) {
      if (getComputedStyle(el).display === 'inline') el.style.display = 'inline-block';
      el.classList.remove('pk-bump'); void el.offsetWidth; el.classList.add('pk-bump');
    });
  }
  var lastCount = null;
  var cnt = D.querySelector('[data-pk-cart-count]');
  if (cnt) {
    lastCount = +cnt.textContent || 0;
    new MutationObserver(function () {
      var v = +cnt.textContent || 0;
      if (v > lastCount) { if (dlg && dlg.open) pendingBump = true; else bump(); }
      lastCount = v;
    }).observe(cnt, { childList: true, characterData: true, subtree: true });
  }


  /* ================= PHASE 2 ================= */
  /* product photo loupe: the zoom follows the cursor (desktop only) */
  function loupe() {
    if (!window.matchMedia('(hover:hover) and (pointer:fine) and (min-width:990px)').matches) return;
    D.querySelectorAll('.pk-pd__zbtn').forEach(function (b) {
      if (b.__pkLp) return; b.__pkLp = 1;
      var im = b.querySelector(':scope > img'); if (!im) return;
      var raf = 0, x = 50, y = 50;
      function set() { raf = 0; im.style.transformOrigin = x + '% ' + y + '%'; }
      b.addEventListener('mouseenter', function () { b.classList.add('pk-lp'); });
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        x = Math.max(0, Math.min(100, (e.clientX - r.left) / r.width * 100));
        y = Math.max(0, Math.min(100, (e.clientY - r.top) / r.height * 100));
        if (!raf) raf = requestAnimationFrame(set);
      });
      b.addEventListener('mouseleave', function () { b.classList.remove('pk-lp'); });
    });
  }

  /* worn-in-real-life rail: tiles rise in, then a gentle peek shows it scrolls */
  function rails() {
    D.querySelectorAll('.pk-wr__rail').forEach(function (r) {
      if (r.__pkRl) return; r.__pkRl = 1;
      [].forEach.call(r.children, function (t, i) { t.style.setProperty('--i', Math.min(i, 6)); });
      r.classList.add('pk-arm');
      onView(r, function (el) {
        el.classList.add('pk-in');
        if (el.scrollWidth <= el.clientWidth + 24 || el.scrollLeft > 0) return;
        setTimeout(function () {
          if (el.__pkTouched) return;
          var snap = el.style.scrollSnapType; el.style.scrollSnapType = 'none';
          tween(700, function (t) { if (!el.__pkTouched) el.scrollLeft = 56 * t; }, function () {
            setTimeout(function () { tween(700, function (t) { if (!el.__pkTouched) el.scrollLeft = 56 * (1 - t); }, function () { el.style.scrollSnapType = snap; }); }, 260);
          });
        }, 1200);
      });
      ['pointerdown', 'wheel', 'touchstart'].forEach(function (ev) { r.addEventListener(ev, function () { r.__pkTouched = 1; }, { passive: true, once: true }); });
    });
  }


  /* ================= PHASE 3 ================= */
  function sparkle(host, delay) {
    setTimeout(function () {
      var s = D.createElement('span'); s.className = 'pk-burst'; s.setAttribute('aria-hidden', 'true');
      s.innerHTML = '<i></i><i></i><i></i><i></i><i></i><i></i>'; host.appendChild(s);
      setTimeout(function () { s.remove(); }, 1300);
    }, delay || 0);
  }
  function emblem() {
    var m = D.querySelector('.pk-f2__mark'); if (!m || m.__pkEm) return; m.__pkEm = 1;
    m.classList.add('pk-arm');
    onView(m, function (el) { el.classList.add('pk-in'); glint(el.querySelector('.pk-f2__emblem'), 1500); });
  }
  D.addEventListener('click', function (e) {
    var w = e.target.closest && e.target.closest('.pk-pd__wish');
    if (w) { w.classList.remove('pk-love'); void w.offsetWidth; w.classList.add('pk-love'); sparkle(w, 180); setTimeout(function () { w.classList.remove('pk-love'); }, 800); }
    var pl = e.target.closest && e.target.closest('.pk-pd__pill');
    if (pl) { setTimeout(function () { pl.classList.remove('pk-tap'); void pl.offsetWidth; pl.classList.add('pk-tap'); setTimeout(function () { pl.classList.remove('pk-tap'); }, 850); }, 20); }
  });

  /* ---------- boot ---------- */
  function boot() { cards(); pdp(); loupe(); rails(); emblem(); }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
  var mt = 0;
  new MutationObserver(function () { clearTimeout(mt); mt = setTimeout(function () { cards(); rails(); }, 250); }).observe(D.body || H, { childList: true, subtree: true });
  D.addEventListener('shopify:section:load', function (e) { cards(e.target); });
})();
